module.exports = __webpack_public_path__ + "img/ee71f36.png";